import { ReactNode } from 'react';
import { Tooltip as LibTooltip } from 'radix-ui';

export type TooltipProps = {
  children: ReactNode;
};

const Tooltip = (props: TooltipProps) => {
  // eslint-disable-next-line react-x/no-context-provider
  return <LibTooltip.Provider delayDuration={0} {...props} />;
};

export { Tooltip };
